/** * 注册防刷滑动验证码 */

<template>
  <div :class="[$style.wrap, fullScreen && $style.fullScreen]">
    <header>
      <span>滑动验证</span>
    </header>
    <main>
      <div :class="$style.content">
        <div id="captcha"></div>
      </div>
    </main>
  </div>
</template>

<script>
import isFullScreen from '@/libs/business/fullScreen';

export default {
  name: '',
  data() {
    return {
      fullScreen: '',
    };
  },
  created() {
    this.fullScreen = isFullScreen();
  },
  mounted() {
    this.$emit('captchaInit');
  },
};
</script>

<style lang="scss" module>
@import '../../../assets/css/common.scss';

.wrap {
  @include common-window();
  > header {
    position: relative;
    > span {
      font-weight: 600;
      font-style: italic;
    }
    .fanhui {
      position: absolute;
      top: 0.35rem;
      right: 0.35rem;
      width: 0.34rem;
      height: 0.25rem;
    }
  }
  > main {
    padding: .34rem .2rem;
    overflow-y: auto;
    position: relative;
    :global {
      #captcha {
        position: absolute;
        width: 4.8rem;
        left: 0;
        right: 0;
        margin: auto;
        top: 1.5rem;
        .nc_1_nocaptcha {
          .nc_wrapper {
            width: 100%;
            .nc_scale {
              background-color: #c8c4bf;
            }
            .scale_text {
              border-radius: 5px;
              box-shadow: 0 0 7px #c8c4bf;
              overflow: hidden;
            }
            .nc-lang-cnt {
              -webkit-text-fill-color: #ffffff;
              color: #ffffff;
              padding-left: 30px;
              font-weight: bold;
            }
            .nc_iconfont {
              height: 34px;
              border-radius: 5px;
              animation: none;
              background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/wanXin/orangeTheme/jiantou_1.png') no-repeat;
              background-size: 100% 100%;
              background-position: center;
              font-size: 0;
            }
            .nc_bg {
              background-color: $primary-color;
            }
          }
        }
      }
    }
  }
  &.fullScreen {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      padding: 17px 10px;
      overflow-y: auto;
      :global {
        #captcha {
          width: 280px;
          top: 75px;
          .nc_1_nocaptcha {
            .nc_wrapper {
              .nc_scale {
                background-color: #c8c4bf;
              }
              .scale_text {
                border-radius: 5px;
                box-shadow: 0 0 7px #c8c4bf;
                overflow: hidden;
              }
              .nc-lang-cnt {
                -webkit-text-fill-color: #ffffff;
                color: #ffffff;
                padding-left: 30px;
                font-weight: bold;
              }
              .nc_iconfont {
                height: 34px;
                border-radius: 5px;
                animation: none;
                background: url('//sdk-static.zhangyuqu.com/Lianyun/SdkImg/wanXin/orangeTheme/jiantou_1.png') no-repeat;
                background-size: 100% 100%;
                background-position: center;
                font-size: 0;
              }
              .nc_bg {
                background-color: $primary-color;
              }
            }
          }
        }
      }
    }
  }
}
</style>
